import { Button } from 'reactstrap';

const FormFooter = ({ drawer, disabled, submit }) => {
  return (
    <div className="h-100p d-flex align-items-end pb-1">
      <div className="d-flex justify-content-end pe-6 border-top w-100p pt-1">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => {
            drawer.close();
          }}
          disabled={disabled}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={disabled} color="primary" className="px-4">
          SAVE
        </Button>
      </div>
    </div>
  );
};

export default FormFooter;
